
import { computed, reactive } from 'vue';

import { storedRef } from './utils.js';

import timelineImagePaths from '../images/activity-4-part-1-timeline-*.jpg';

const activity = 4;

export const timeline = reactive( [ {

  id: 2,

  year: '1619',

  title: 'Slavery Comes to North America',

  description: 'The first slaves in the U.S. were brought to Jamestown, Virginia in 1619.',

  images: [ {

    path: timelineImagePaths[ '2' ],

    alt: 'Illustration of historic Jamestown in 1619. Slaves are on the ground surrounded by guards and onlookers. A ship is in the background.'

  } ]

}, {

  id: 3,

  year: '1777',

  title: 'Northern States and Territories Begin Abolishing or Limiting Slavery',

  description: 'Vermont and Pennsylvania were among the first U.S. states to abolish slavery.',

  images: [ {

    path: timelineImagePaths[ '3' ],

    alt: 'Therefore, no male person, born in this country, or bought from overseas, ought to be holden by law, to serve any person, as a servant, slave.',

    caption: 'Vermont State Constitution, July 8, 1777.'

  } ]

}, {

  id: 4,

  year: '1793',

  title: 'Fugitive Slave Act Enacted',

  description: 'The Fugitive Slave Act made it unlawful to assist an enslaved person trying to escape.'

}, {

  id: 5,

  era: 'Early 1800s',

  title: 'Underground Railroad Established',

  description: 'The Underground Railroad was a secret network of abolitionists, free blacks, and others who offered aid to escaped enslaved people.',

  images: [ {

    path: timelineImagePaths[ '5' ],

    alt: 'Harriet Tubman standing with her hands clasped on the back of a vintage chair. Labeled \'Harriet Tubman 1823-1913, nurse, spy and scout.\'',

    caption: 'Harriet Tubman escaped slavery and then assisted many others using the Underground Railroad network.'

  } ]

}, {

  id: 6,

  year: '1804',

  title: 'Northern States Abolish Slavery or Set Measures to End It',

}, {

  id: 7,

  year: '1808',

  title: 'Congress Outlaws the Import of New Enslaved People',

}, {

  id: 8,

  year: '1862',

  title: 'Preliminary Emancipation',
  
  description: 'President Lincoln issued a preliminary emancipation freeing all slaves in rebel states if they did not cease fighting and rejoin the Union by January 1, 1863.',

  images: [ {

    path: timelineImagePaths[ '8' ],

    alt: 'Emancipation Proclamation: Lincoln\'s order to free Confederate slaves.'

  } ]
  
}, {

  id: 9,

  year: '1865',

  title: 'Civil War Ends',
  
  description: 'Once fighting ceased, the nation began the arduous task of finding a way forward as a unified nation.',

  images: [ {

    path: timelineImagePaths[ '9' ],

    alt: 'Soldiers sitting on a fence and a crowd of people behind them at the entrance and upper terrace of the Appomattox Court House.',

    caption: 'McLean House in Appomattox Court House, Virginia was the site of the Civil War surrender conference.'

  } ]

}, {

  id: 10,

  year: '1865',

  title: '13th Amendment',
  
  description: 'Passed by Congress on January 31, 1865, and ratified on December 6, 1865, the 13th Amendment abolished slavery in the United States.'

}, {

  id: 11,

  year: '1865',

  title: 'Southern States Retaliate with "Jim Crow" Laws',
  
  description: 'After a brief period of educational and social strides forward for Black Americans, Southern states began enacting laws which legalized racial segregation and marginalized African Americans. These laws existed for 100 years.',

  images: [ {

    path: timelineImagePaths[ '11' ],

    alt: 'A Black man standing under a sign at a bus station. The sign states, \'Colored Waiting Room.\'',

    caption: 'Source: Library of Congress.'

  } ]

}, {

  id: 12,

  year: '1868',

  title: '14th Amendment',
  
  description: 'The 14th Amendment covers many rights, but a major provision granted citizenship and equal civil and legal rights to African Americans.'

}, {

  id: 13,

  year: '1870',

  title: '15th Amendment',
  
  description: 'The 15th Amendment gave African Americans the right to vote.'

}, {

  id: 14,

  year: '1877',

  title: 'Last Federal Forces Leave the South',
  
  description: 'President Hayes ordered the last troops to withdraw. Unfortunately, this effectively ended Reconstruction and gave rise to the Jim Crow system.',

  images: [ {

    path: timelineImagePaths[ '14' ],

    alt: 'Three sketches depicting the last federal forces leaving the south: 1. Fort Packard the Inner Courtyard of the State House, 2. The Salute on the Levee in Honor of the Evacuation, and 3. U.S. troops leaving the Orleans Hotel.',

    caption: 'Illustration: Federal troops leaving New Orleans as part of the Compromise of 1877.'

  } ]

}, {

  id: 15,

  year: '1896',

  month: 'May',
  
  day: '18',

  title: 'Plessy v. Ferguson',
  
  description: 'The Supreme Court establishes the legality of Jim Crow laws. The Supreme Court found in Plessy v. Ferguson that segregation laws did not violate the Constitution as long as separate facilities were equal in quality.'

}, {

  id: 16,

  year: '1909',

  title: 'NAACP Founded',
  
  description: 'The National Association for the Advancement of Colored People was founded in response to the ongoing violence against Black people and the infringement of their rights.',

  images: [ {

    path: timelineImagePaths[ '16' ],

    alt: 'NAACP Logo featuring a book and the scales of justice. Small text reads \'Founded 1909\'.',

    caption: 'The logo of the NAACP.'

  } ]

}, {

  id: 17,

  year: '1926',

  title: 'Shenandoah National Park Authorized by Congress',
  
  description: 'Congress authorizes Shenandoah National Park. The Commonwealth of Virginia, under the direction of Governor Harry F. Byrd, Sr., begins raising funds and planning for its new national park.'

}, {

  id: 18,

  year: '1931',

  title: 'Construction on Scenic Highway "Skyline Drive" Begins',
  
  description: 'Even before Shenandoah was legally established, work on Skyline Drive began and plans for facilities were in full swing.',

  images: [ {

    path: timelineImagePaths[ '18' ],

    alt: 'A view, framed by trees, showing early construction of Skyline Drive, still a dirt track winding through mountains.'

  } ]

}, {

  id: 19,

  year: '1932',

  title: 'Recommendation to Provide for "Colored Guests" at Shenandoah',
  
  description: 'Associate Director of the NPS Arno Cammerer wrote a letter to Director Albright with detailed suggestions for the development of facilities in the new park. A handwritten afterthought note read, "Provision for colored guests."'

}, {

  id: 20,

  year: '1936',

  month: 'March',
  
  day: '6',

  title: 'Senator Harry F. Byrd, Sr. Pushes for Segregation',
  
  description: 'Senator Byrd (former Governor) comments on segregation in Shenandoah: "When the park was established, it was agreed that all laws governing the state of Virginia would be in effect within the Park area."',

  images: [ {

    path: timelineImagePaths[ '20' ],

    alt: 'Photo portrait of Senator Harry F. Byrd, SR. sitting with his hands clasped against a dark background.',

    caption: 'Although devoted to the idea of a national park in Virginia, Senator Byrd was an avowed segregationist.'

  } ]

}, {

  id: 21,

  year: '1936',

  month: 'July',

  day: '6',

  title: 'Shenandoah National Park Dedicated',
  
  description: 'President Franklin D. Roosevelt dedicates Shenandoah National Park in a ceremony broadcast live via radio from Big Meadows.',

  images: [ {

    path: timelineImagePaths[ '21' ],

    alt: 'President Franklin D. Roosevelt delivers a speech from a podium during the dedication of Shenandoah National Park. Uniformed officers are in the foreground.'

  } ]

}, {

  id: 22,

  year: '1936',

  month: 'September',
  
  day: '18',

  title: 'Washington Acknowledges Need for Segregated Facilities',
  
  description: 'Associate Director of the National Park Service Arthur Demaray agrees that separate facilities for white and colored guests will be needed at Shenandoah, in keeping with "the generally accepted customs long established in Virginia." These include comfort stations, cabins, and picnic grounds.',

  images: [ {

    path: timelineImagePaths[ '22' ],

    alt: 'Highlighted excerpt from a letter from Director of the National Park Service, Arthur Demaray: \'To render the most satisfactory services to white and colored visitors it is generally recognized that separate restrooms, cabin colonies and picnic ground facilities should be provided.\''

  } ]

}, {

  id: 23,

  year: '1937',
  
  month: 'February',

  title: '"Colored" Facilities Included in Development Plan',
  
  description: 'The Virginia Sky-Line Company presents a plan that includes a campground, cabins, and a small lodge to accommodate "colored people."',

  images: [ {

    path: timelineImagePaths[ '23' ],

    alt: 'Historic, wooden signage at Lewis Mountain entrance that reads: Lewis Mountain Negro Area, Coffee Shop and Cottages, Campground, Picnic Ground, Entrance.'

  } ]

}, {

  id: 24,

  year: '1937',

  month: 'July',

  day: '26',

  title: 'Lassiter Is Instructed to Speed Up Construction',
  
  description: '"Two bus loads are going up tomorrow… this is not a good condition..."',

  images: [ {

    path: timelineImagePaths[ '24' ],

    alt: 'Highlighted excerpt from a letter to Superintendent Lassiter, Shenandoah National Park: \'Two bus loads are going up tomorrow and they have to be fitted into camping places for the white people. This is not a good condition.\''

  } ]

}, {

  id: 25,

  year: '1939',

  month: 'January',

  day: '17',

  title: 'DOI Solicitor Calls the Plan "Unconstitutional"',
  
  description: 'Department of the Interior solicitor informs Secretary Ickes that the planned facilities for Negros at Lewis Mountain are unconstitutional as they are separate, but not equal. Lewis Mountain is still incomplete.'

}, {

  id: 26,

  year: '1939',

  month: 'February',

  day: '8',

  title: 'Lassiter Defends Lewis Mountain',
  
  description: '"Lewis Mountain has as good an outlook and as good surroundings, if not better, than Elkwallow or South River."',

  images: [ {

    path: timelineImagePaths[ '26' ],

    alt: 'Highlighted excerpt from a letter written by Superintendent Lassiter, Shenandoah National Park: \'Lewis Mountain has as good an outlook and as good surroundings, if not better than Elkwallow or South River.\''

  } ]

}, {

  id: 27,

  year: '1939',

  month: 'March',

  day: '25',

  title: 'Ickes Designates Pinnacles Picnic Grounds to Be Open to Both Races',
  
  description: 'Ickes requests one large picnic area in Shenandoah to be open to everyone with no signs indicating racial segregation. Lassiter picks Sexton Knoll (Pinnacles) for both races. Space for Black diners is allocated at Panorama and Swift Run. Ickes would later write in his secret diary that he used Shenandoah as a "race relations laboratory."',

  images: [ {

    path: timelineImagePaths[ '27' ],

    alt: 'Highlighted excerpt from a letter written by Harold L. Ickes, Secretary of the Interior: \'I wish to advise that the Sexton Knoll picnic ground in the central section of the Park will be used jointly by both white and colored.\''

  } ]

}, {

  id: 28,

  year: '1939',

  month: 'August',

  title: 'Part of Lewis Opens; First Steps Towards Desegregation',
  
  description: 'Picnic grounds at Lewis are opened. Lassiter reports Lewis is being well used, however, joint use of Pinnacles has had complaints.',

  images: [ {

    path: timelineImagePaths[ '28' ],

    alt: 'A portion of a map of Shenandoah National Park with a large black arrow pointing to the following label: \'Lewis Mountain Picnic Ground for Colored People.\''

  } ]

}, {

  id: 29,

  year: '1940',

  month: 'March',

  day: '15',

  title: 'Washington Removes Segregated Labeling on Park Maps',
  
  description: 'The Department of the Interior issues a directive forbidding the "mention… of segregation on the map or in the park literature." Lassiter objects to this policy as illogical and is soon reassigned.',

  images: [ {

    path: timelineImagePaths[ '29-a' ],

    alt: 'Highlighted excerpt from a memorandum for Acting Superintendent, Shenandoah National Park: \'This is in accord with suggestions of the Department, and no mention will be made of segregation on the map or in the park literature.\''

  }, {

    path: timelineImagePaths[ '29-b' ],

    alt: 'A portion of a map of Shenandoah National Park showing the following areas without any segregated labeling: Big Meadows, Crescent Rock, Lewis Mountain, South River, and Swift Run Gap.'

  } ]

}, {

  id: 30,

  year: '1940',

  month: 'May',

  day: '2',

  title: 'Virginia Sky-Line Co. Argues Lewis Would Be a "Distinct Loss"',
  
  description: 'Cammerer supports Sky-Line\'s argument. The following month, Cammerer is demoted from Director and moved out of Washington D.C. Newton Drury becomes Director of the National Park Service.',

  images: [ {

    path: timelineImagePaths[ '30' ],

    alt: 'Highlighted excerpt from a memorandum to Virginia Skyline Company: \'it would seem that this operation will probably be operated at a distinct loss.\''

  } ]

}, {

  id: 31,

  year: '1940',

  month: 'July',

  day: '28',

  title: 'Rangers Enforcing Segregation Are Met With Complaints'
  
}, {

  id: 32,

  year: '1940',

  month: 'August',

  day: '1',

  title: 'Lassiter Disagrees with Washington',
  
  description: 'Lassiter to Director of NPS: "I still don\'t understand how a Negro is to know that there is a place in the Park for him if we are afraid to publish such a fact." Same day: Lassiter responds to U.S. Travel Bureau: "All information in the official booklet... that this area is for the exclusive use of Negros was deleted by the Washington office..." By the end of the 1941 season, Lassiter would be demoted and transferred out of Shenandoah.',

  images: [ {

    path: timelineImagePaths[ '32' ],

    alt: 'Highlighted excerpts from Superintendent Lassiter a memorandum written to the Director of the National Park Service: \'I believe that what we need is more and bigger For White Only signs,\' and \'I think the best policy to pursue is definite segregation.\''

  } ]

}, {

  id: 33,

  year: '1941',

  month: 'February',

  day: '25',

  title: 'Notice to Desegregate All Picnic Grounds',
  
  description: 'NPS Director Newton Drury informed Shenandoah Superintendent Lassiter that there would be no segregation on any of the picnic grounds in 1941 and that there would be no publicity about the change.',

  images: [ {

    path: timelineImagePaths[ '33' ],

    alt: 'Highlighted excerpts from a memorandum written to Superintendent Lassiter by National Park Service Director Newton Dury: \'during the coming year no segregation will be exercised in any of the picnic grounds,\' and \'negro use will be carefully observed, and that no publicity or statements will be given out locally regarding this decision.\''

  } ]

}, {

  id: 34,

  year: '1942',

  month: 'July',

  title: 'Shenandoah Closes During Wartime',
  
  description: 'During World War II, gasoline was rationed and visitation to Shenandoah plummeted. Virginia Sky-Line Company facilities closed and did not reopen until September 1945.'

}, {

  id: 35,

  year: '1945',

  month: 'December',

  title: 'New Directive from Washington: Move to Full Integration',
  
  description: 'When the Park reopened after WWII, the Department of the Interior issued a directive that all facilities must be integrated; The Virginia Sky-Line Company refused. Since it was too late to contract a new concessioner, and under pressure from Senator Byrd, the Department of the Interior allowed segregation to continue for the 1946 season.',

  images: [ {

    path: timelineImagePaths[ '35' ],

    alt: 'Highlighted excerpt from a memorandum written by Virginia Skyline Company: \'This regulation, would be in direct violation of the agreement under which we have been operating our facilities in the Park since 1939, and would, in our opinion, create an intolerable situation.\''

  } ]

}, {

  id: 36,

  year: '1947',

  month: 'October',

  title: 'Lewis Mountain and the Main Dining Room at Panorama Desegregates'
  
}, {

  id: 37,

  year: '1948',

  title: 'Truman Integrates U.S. Armed Forces'
  
}, {

  id: 38,

  year: '1950',

  month: 'July',

  title: 'Full Integration at Shenandoah',
  
  description: 'A Park planner from Washington reports no segregation. Shenandoah is officially one of the first public places in Virginia to desegregate.'

}, {

  id: 39,

  year: '1954',

  month: 'May',
  
  day: '17',

  title: 'Brown v. Board of Education',
  
  description: 'U.S. Supreme Court issues its unanimous ruling in civil rights case Brown v. Board of Education of Topeka, Kansas; state-sanctioned segregation of public schools is a violation of the 14th amendment and therefore unconstitutional. However, the court failed to explain how quickly and in what manner desegregation was to be achieved. This lack of clarification leads to the Massive Resistance movement in Virginia.',

  images: [ {

    path: timelineImagePaths[ '39' ],

    alt: 'A group of young white and Black girls wearing dresses standing in line in a classroom.'

  } ]

}, {

  id: 40,

  year: '1956',

  title: 'Rosa Parks Refuses to Give Up Her Bus Seat to a White Man',
  
  description: 'Mrs. Parks\' act of civil disobedience was one of many that began to challenge the status quo of marginalizing African Americans through Jim Crow laws.',

  images: [ {

    path: timelineImagePaths[ '40' ],

    alt: 'A group of individuals, including Rosa Parks. The photo is dated June, 1963.'

  } ]

}, {

  id: 41,

  year: '1956',

  title: 'Massive Resistance',
  
  description: 'U.S. Senator Harry F. Byrd, Sr. calls for a strategy of "Massive Resistance" to oppose the integration of public schools in Virginia.',

  images: [ {

    path: timelineImagePaths[ '41' ],

    alt: 'A group of Black individuals holding protest signs. One reads, \'I have lost four years of education. Why five? Let\'s tell Russia about this.\'',

    caption: 'With Senator Byrd\'s support and encouragement, several jurisdictions close schools rather that desegregate.'

  } ]
  
}, {

  id: 42,

  year: '1956',

  title: 'The Little Rock Nine',
  
  description: 'Under federal troop escort, the Little Rock Nine made it inside Central High School in Arkansas for their first full day of school.'

}, {

  id: 43,

  year: '1960',

  title: 'Sit-in at Woolworth\'s',
  
  description: 'Another prominent act of civil disobedience that was a catalyst to other nonviolent events that contributed to change.',

  images: [ {

    path: timelineImagePaths[ '43' ],

    alt: 'Several Black individuals sitting on barstools at a department store food counter.'

  } ]
  
}, {

  id: 44,
  
  year: '1960',
  
  title: 'Ruby Bridges Attends School',
  
  description: 'Ruby Bridges becomes the first African American student to integrate an elementary school in the South. She was 6 years old.',

  images: [ {

    path: timelineImagePaths[ '44' ],

    alt: 'Six-year-old Ruby Bridges, a Black student, attends her first day at her new school accompanied by three white U.S. Marshals.'

  } ]

}, {

  id: 45,

  year: '1963',

  title: 'March On Washington',
  
  description: 'Another nonviolent, high-profile event that contributed to the success of the passing of the Civil Rights Act in 1964.',

  images: [ {

    path: timelineImagePaths[ '45' ],

    alt: 'A Black man, Martin Luther King Jr., raising his right arm and waving to a huge crowd below him in Washington D.C.',

    caption: 'Copyright: &copy; 2008-2017 Wes Candela Photography, LLC.'

  } ]

}, {

  id: 46,

  year: '1964',

  title: 'Civil Rights Act',
  
  description: 'The most sweeping civil rights legislation since Reconstruction, this Act finally prohibited discrimination, integrated schools and other public facilities, and made employment discrimination illegal.'

}, {

  id: 47,

  year: '1965',

  title: 'Voting Rights Act',
  
  description: 'This act outlawed discriminatory voting practices.'

}, {

  id: 48,

  year: '1968',

  title: 'The Green Book Ceases Publication',
  
  description: '"There will be a day sometime in the near future when this guide will not have to be published. That is when we as a race will have equal opportunities and privileges in the United States. It will be a great day for us to suspend this publication for then we can go wherever we please, and without embarrassment." &mdash; Victor H. Green, author of The Green Book"',

  images: [ {

    path: timelineImagePaths[ '48' ],

    alt: 'Photo portrait of a Black man, Victor Hugo Green.',

    caption: 'Victor Hugo Green, circa 1956-58.'

  } ]

} ].map( obj => ( {
  
  ...obj,
  
  selected: storedRef( activity, `timeline-${ obj.id }`, false ),

  response: storedRef( activity, `response-${ obj.id }`, null )

} ) ) );

export const selections = computed( () => timeline.reduce( ( count, { selected } ) => selected ? count + 1 : count, 0 ) );

export const selected = computed( () => timeline.filter( ( { selected } ) => selected ) );

export const seenPlayerDialog = storedRef( activity, 'seen-player-dialog', false );

export const hasDownloaded = storedRef( activity, 'has-downloaded', false );
